export default "__VITE_ASSET__sxdizupg__"